<template>
  <div class="toolbar-button-container">
    <div class="toolbar-tooltip-container">
      <div class="toolbar-tooltip qrw-paragraph-xs bold">
        {{ text }}
      </div>
      <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.70711 5.29289C6.31658 5.68342 5.68342 5.68342 5.29289 5.29289L0 0L12 0L6.70711 5.29289Z"
          fill="#1F1F1F"
        />
      </svg>
    </div>

    <BaseIconButton
      size="sm"
      variant="ghost"
      hoverColor="overlay-8-inverse"
      @click="$emit('click')"
      textColor="content-base-inverse-primary"
      :icon="icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
  },
};
</script>

<style>
.toolbar-tooltip-container {
  position: absolute;
  top: -44px;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.toolbar-button-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
}

.toolbar-button-container:hover .toolbar-tooltip-container {
  display: flex;
}

.toolbar-tooltip {
  color: var(--qrw-content-base-inverse-primary);
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
  background: var(--qrw-background-base-inverse-primary);

  border-radius: 4px;
  transform: 0.1s;
  white-space: nowrap;
}
</style>
